// extracted by mini-css-extract-plugin
export default {"request-approval__container":"styles_request-approval__container__vK2AN"};